import { requestLogout } from './requestLogout';
import { logout } from './requestLogoutActions';

export { logout };

export default requestLogout;
